import React from 'react';

import { useI18n } from '../../hooks/useI18n';

import styles from './_TopTenPosition.module.css';

export const TopTenPosition: React.FC<{ position: number }> = ({ position }) => {
    const i18n = useI18n();
    return (
        <span aria-hidden className={styles.positionText}>
            {i18n('movie_info__top10_text_position', { position })}
        </span>
    );
};
